import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ScrollArea } from "@mantine/core";
import { useCallback, useState } from "react";
import { AppDrawer } from "../../shared/AppDrawer";
import { Confirmation } from "../../shared/Confirmation";
import { TabGroup } from "../../shared/Tabs/TabGroup";
import { TabWithChildren } from "../../shared/Tabs/TabWithChildren";
import { NotificationSettingsView } from "../notification-settings/NotificationSettingsView";
import { PriorityOrderView } from "../priority-view/PriorityOrderView";
import { PriorityStatusView } from "../priority-status/PriorityStatusView";
import { SimpleEmailTemplateView } from "../simple-email-template/SimpleEmailTemplateView";
import { SettingsLocationsTab } from "./SettingsLocationsTab";
import { SettingsOrganizationTab } from "./SettingsOrganizationTab";
export const SettingsDrawer = ({ opened, close }) => {
    // State
    const [confirmOpen, setConfirmOpen] = useState(false);
    // Track whether the org form has unsaved changes.
    // The org tab calls this whenever its dirty state changes.
    const [isOrgDirty, setIsOrgDirty] = useState(false);
    const handleOrgDirtyChange = useCallback((dirty) => {
        setIsOrgDirty(dirty);
    }, []);
    // Intercept drawer close — show confirmation if org form is dirty
    const handleClose = () => {
        if (isOrgDirty) {
            setConfirmOpen(true);
        }
        else {
            close();
        }
    };
    const handleConfirmLeave = async () => {
        setConfirmOpen(false);
        setIsOrgDirty(false);
        close();
    };
    return (_jsxs(_Fragment, { children: [_jsx(AppDrawer, { title: "Settings", size: "lg", scrollAreaComponent: ScrollArea.Autosize, opened: opened, onClose: handleClose, stackId: "settings", children: _jsxs(TabGroup, { changeUrl: false, children: [_jsx(TabWithChildren, { label: "Organization", children: _jsx(SettingsOrganizationTab, { opened: opened, onDirtyChange: handleOrgDirtyChange }) }), _jsx(TabWithChildren, { label: "Notification Settings", children: _jsx(NotificationSettingsView, { opened: opened }) }), _jsx(TabWithChildren, { label: "Referral Stage", children: _jsx(PriorityStatusView, { opened: opened }) }), _jsx(TabWithChildren, { label: "Custom Views", children: _jsx(PriorityOrderView, { opened: opened }) }), _jsx(TabWithChildren, { label: "Email Templates", children: _jsx(SimpleEmailTemplateView, { opened: opened }) }), _jsx(TabWithChildren, { label: "Locations", children: _jsx(SettingsLocationsTab, { opened: opened }) })] }) }), _jsx(Confirmation, { action: "leave", additionalText: "You have unsaved changes that won't be saved.", opened: confirmOpen, close: () => setConfirmOpen(false), handleAction: handleConfirmLeave })] }));
};
